<template>
  <div class="mainDiv">
    <!-- <h3 class="header">{{ courseTitle }} - 课程考核</h3> -->
    <AssessmentEdit />
    <CourseAssessmentSetting />
  </div>
</template>

<script>
import AssessmentEdit from './Assessment-edit'
import CourseAssessmentSetting from './Course-assessment-setting'
import { getViewCourseDetail } from '@/api/course/courseInformation'
export default {
  components: {
    AssessmentEdit,
    CourseAssessmentSetting,
  },
  data() {
    return {
      id: this.$route.query.courseId || this.$route.query.id,
      courseTitle: '',
    }
  },
  created() {
    // this.getViewCourseDetail()
  },
  methods: {
    async getViewCourseDetail() {
      const id = this.id
      this.courseTitle = (
        await getViewCourseDetail({ id })
      ).data.data.videoTitle
    },
  },
}
</script>

<style lang="scss" scoped>
.mainDiv {
  .header {
    margin-bottom: 30px;
  }
}
</style>